import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import { MeteringDeviceStatus } from '@/features/meteringDeviceStatus/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import './mocks/mockApi';

export const meteringDeviceStatusApi = createApi({
  reducerPath: 'meteringDeviceStatusApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/metering-device-statuses`,
  }),
  tagTypes: ['MeteringDeviceStatus'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getMeteringDeviceStatuses: builder.query<MeteringDeviceStatus[], void>({
      query: () => ({
        url: `/`,
      }),
    }),
  }),
});

export const { useGetMeteringDeviceStatusesQuery } = meteringDeviceStatusApi;
